export default "__VITE_ASSET__2h$eqWdLjjj$zuUvyPi$HQ__"